import { ReactFragment } from 'react'
import { Alert } from 'reactstrap'

type TodoProps = {
    title?: string
    children: ReactFragment
}

const Todo = ({ children, title }: TodoProps) => <Alert color="warning todo"><h4 className="alert-heading">{ title ?? 'Todo' }</h4>{children}</Alert>

export default Todo